import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import registerBeforeHooks from './before'
import scrollBehavior from './scroll-behavior'

Vue.use(Router)

const router = new Router({
  routes,
  scrollBehavior,
  mode: 'history',
  linkActiveClass: 'active'
})

registerBeforeHooks(router)

export default router
